import React from 'react';
import { useMutation } from 'react-apollo';
import deleteMeetingsMutation from 'queries/meetings/deleteMeetingsMutation.gql';
import listMeetingsQuery from 'queries/meetings/listMeetingsQuery.gql';
import { ConfirmModal } from 'components/Modals/ConfirmModal/ConfirmModal';
import { Meeting } from 'typings/types';

interface Props {
  closeModal: () => void;
  resetSelection: () => void;
  confirmTitle: string;
  confirmButtonText: string;
  errorMessage: string;
  uuid: string;
  serialNumber: string;
  selectionArray: string[];
}

const DeleteMeetingsModal = (props: Props) => {
  const {
    selectionArray,
    closeModal,
    confirmTitle,
    confirmButtonText,
    errorMessage,
    resetSelection
  } = props;

  const [ deleteMeetings, { loading } ] = useMutation(
    deleteMeetingsMutation,
    {
      update(cache: { writeQuery: Function, readQuery: Function }, {data: { deleteListOfMeetings }}: { data: { deleteListOfMeetings: Array<{}>} }) {
        const response: { directoryList: { records: {}[] } } | null = cache.readQuery({
          query: listMeetingsQuery
        });
        const directoryList = response?.directoryList;
        if (directoryList) {
          directoryList.records = directoryList.records.filter((r: Meeting) => {
            return !deleteListOfMeetings.find((uuid: string) => {
              return uuid === r.UUID;
            });
          });
        }

        cache.writeQuery({
          query: listMeetingsQuery,
          data: { directoryList }
        });
      }
    }
  );

  return (
    <ConfirmModal
      confirmTitle={confirmTitle}
      confirmButtonText={confirmButtonText}
      isBusy={loading}
      errorMessage={errorMessage}
      closeModal={closeModal}
      confirmAction={async () => {
        try {
          await deleteMeetings({
            variables: {
              uuids: selectionArray,
            }
          });
          resetSelection();
          closeModal();
        } catch (e) {
          // console.log('error', e);
        }
      }}
    />
  );
};

export default DeleteMeetingsModal;
